<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    disable: collectedReportForm.invalid,
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getReport()"
>
  <form class="collected-container" [formGroup]="collectedReportForm">
    <app-from-to-date
      [fromControl]="'fromDate'"
      [toControl]="'toDate'"
      [formGroupValue]="collectedReportForm"
    ></app-from-to-date>

    <!-- Report Format -->
    <ion-row>
      <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
        <app-report-format
          [radioButtonValue]="collectedReportForm.get('reportFormat')?.value"
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>

    <!-- Note -->
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"></app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    cODCollectedReport && cODCollectedReport.response.CODCollectedCleared
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
  [columnDataFontSize]="'10px'"
  [columnWidths]="[85, 50, 125, 115, 100, 75, 60, 45, 75, 75, 100, 85, 75]"
>
  @if (cODCollectedReport && cODCollectedReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOCATION }}
            {{ cODCollectedReport.response.location }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.TURN_IN }}
            {{ cODCollectedReport.response.turninDate }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  @if (cODCollectedReport && cODCollectedReport.response) {
    <ng-container total>
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">
            {{ PDF_REPORT.FOOTER.TOTAL_EXPECTED }}
            {{ cODCollectedReport.response.TotalExpectedCOD }}
          </td>
          <td class="pdf-total-cell">
            {{ PDF_REPORT.FOOTER.TURNED_IN }}
            {{ cODCollectedReport.response.TotalTurnedInCOD }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>
